import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop({ history }) {
    useEffect(() => {
        const listenHistory = history.listen(() => {
            window.scrollTo(0,0);
        });
        return () => {
            listenHistory();
        }
    }, []);

    return (null);
}

export default withRouter(ScrollToTop);